module.exports = __webpack_public_path__ + "img/malaysia.075910e1.png";